// extracted by mini-css-extract-plugin
export default {"root":"Consist_root__KomP6","placeHolderShimmer":"Consist_placeHolderShimmer__cEVVI"};